import { render, staticRenderFns } from "./InspectionInstrumentList.vue?vue&type=template&id=be2675ce"
import script from "./InspectionInstrumentList.vue?vue&type=script&lang=js"
export * from "./InspectionInstrumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports